import { isString } from '@polkadot/util';
export function typeToConstructor(registry, type) {
    return (isString(type)
        ? registry.createClassUnsafe(type)
        : type);
}
